<template>
	<div id="quant_jyjy">
		<v-chart class="quant_jyjy" :options="line" :theme="echartsTheme" :key="echartsTheme"/>
		
		<div class="row">
			<div class="col col-md-2">
			<b-alert show>
				<b-form-datepicker v-model="calendarDate" size="sm" @input="onCalendarInput"></b-form-datepicker>
				<b-form-checkbox v-model="showAllKlines" size="sm">显示全部K线</b-form-checkbox>
				<b-form-checkbox v-model="showPopularAll" size="sm">显示人气</b-form-checkbox>
				<div class="d-flex align-items-center flex-nowrap">
					<small class="mr-2 mb-0">每行图数</small>
					<b-form-select v-model.number="klineCols" :options="[1,2,3,4]" size="sm" class="mr-2 w-auto" />
				</div>
				<div v-if="showAllKlines && stocks_pool.length>0" class="mt-2">
					<div class="d-flex align-items-center">
						<small class="mr-2">每页</small>
						<b-form-select v-model.number="pageSize" :options="[5,10,20,50]" size="sm" class="mr-2" />
						<small class="mr-2">页 {{currentPage}} / {{totalPages}}</small>
						<b-button size="sm" class="mr-1" @click="prevPage" :disabled="currentPage<=1">上一页</b-button>
						<b-button size="sm" @click="nextPage" :disabled="currentPage>=totalPages">下一页</b-button>
					</div>
				</div>
				前一天选出:
					<div v-if="quant_code==9008">
					<div v-bind:key="data.index" v-for="(data) in stocks_pool" class="border">
						<!-- <div>{{data.rank}}{{data.symbol_name}}({{data.symbol_code}})</div> -->
						<StockTextPopularItem @p_show_kline="show_kline" :rank="data.rank"  :rank_diff="data.rank_diff" :stock_name="data.symbol_name" :stock_code="data.symbol_code" :pct="Number(data.pct_pre1*100).toFixed(2)"></StockTextPopularItem>			
					</div>
					</div>
					<div  v-else>
					<div v-bind:key="data.index" v-for="(data) in stocks_pool" class="border">
						<!-- <div>{{data.rank}}{{data.symbol_name}}({{data.symbol_code}})</div> -->
						<StockTextPopularItem @p_show_kline="show_kline" :rank="data.rank"  :rank_diff="data.rank_diff" :stock_name="data.symbol_name" :stock_code="data.symbol_code" :pct="data.pct_pre1"></StockTextPopularItem>			
					</div>
					</div>
				</b-alert>
			</div>
			<div class="col col-md-10">
				<StockKlineWithPopular  :symbol_code="symbol_code" :highlightDate="buyDate"  :title="symbol_code" :subText="symbol_name"></StockKlineWithPopular>
				<div v-if="showAllKlines && stocks_pool.length>0" class="mt-3">
					<div class="row">
						<div v-for="data in pagedStocks" :key="data.symbol_code" :class="klineColClass" class="mb-3">
							<StockKlineDay v-if="!showPopularAll" :symbol_code="data.symbol_code" :title="data.symbol_name" :subText="data.symbol_code" :highlightDate="buyDate" :chart_heigh="'300px'"></StockKlineDay>
							<StockKlineWithPopular v-else :symbol_code="data.symbol_code" :title="data.symbol_name" :subText="data.symbol_code" :highlightDate="buyDate" :chart_heigh="'300px'"></StockKlineWithPopular>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>Test:{{symbol_code}}</div>
	</div>
</template>

<script>
	import ECharts from 'vue-echarts'
	import axios from 'axios'
	import StockTextPopularItem from 'components/stock/StockTextPopularItem.vue'
	import StockKlineWithPopular from 'components/stock/StockKlineWithPopular.vue'
	import StockKlineDay from 'components/stock/StockKlineDay.vue'
	import {
		request_zzquant
	} from "network/request.js"

	const upColor = '#ec0000';
	const upBorderColor = '#8A0000';
	const downColor = '#00da3c';
	const downBorderColor = '#008F28';

	export default {
		props: {
			quant_code: {
				type: String,
				default: "9010"
	},
        
			title: {
				type: String,
				default: "九阴九阳策略"
			},
			subText: {
				type: String,
				default: "周期分析"
			},
			zoom_start: {
				type: [Number, String],
				default: 70,
			},
				zoom_end: {
					type: Number,
					default: 100,
				},
				all_page_size: {
					type: Number,
					default: 10,
				},
				all_page_start: {
					type: Number,
					default: 1,
				},
			},
		mounted() {
			this.refresh();
			// this.timer = setInterval(() => {  //创建定时器
			// 	this.refresh_interval();
			// }, 60000);
		try{ const t = localStorage.getItem('site.theme'); if(t){ this.theme = t } }catch(e){ console.warn('theme read failed', e) }
			this.onThemeChanged = (e)=>{ const theme = e && e.detail && e.detail.theme ? e.detail.theme : (localStorage.getItem('site.theme')||'light'); this.theme = theme }
			window.addEventListener('site-theme-changed', this.onThemeChanged)
		},
	components: {
		'v-chart': ECharts,
			StockTextPopularItem,
			StockKlineWithPopular,
			StockKlineDay
		},
		data() {
			return {
				theme:'light',
			stocks_pool:[],
				timer: null, //首先我在data函数里面进行定义定时器名称
				symbol_code:'601216',
				symbol_name:'',
				buyDate:'',
				showAllKlines:false,
				showPopularAll:false,
				klineCols: 2,
				calendarDate:'',
				currentPage: this.all_page_start || 1,
				pageSize: this.all_page_size || 10,
				line: {
					title: {
						text: this.title,
						subtext: this.subText,
						left: 0
				},
					
					toolbox: { //下载
						show: true,
						feature: {
							saveAsImage: {}
						}
					},
				legend: {
						top: 10,
						left: 'center',
						data: ['赚钱效应', '亏钱效应', '涨停数']
					},
					visualMap: {
						// top: 10,
						// right: 10,
						type : 'piecewise',
						show: false,
						seriesIndex: 0,
						dimension:1,
						pieces: [
							{min: parseFloat(75), color: upBorderColor },
							{min: parseFloat(45), max: parseFloat(75), color: upColor},
							{min: parseFloat(35), max: parseFloat(45), color: downColor},
							{min: parseFloat(0), max: parseFloat(35), color: downBorderColor},
							],
						outOfRange: {
							symbol: 'rect', 
							symbolSize: [1,1],
							color:upBorderColor,
						}
					},
					grid: [{
							left: '8%',
							right: '8%',
							height: '50%'
						},
						{
							left: '8%',
							right: '8%',
							top: '70%',
							height: '20%'
						}
					],
					xAxis: [{
							gridIndex: 0,
							type: 'category',
							scale: true,
							boundaryGap: false,
							axisLine: {
								onZero: false
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10
							},
						},
						{
							gridIndex: 1,
							type: 'category',
							scale: true,
							// boundaryGap: false,
							axisLine: {
								onZero: false
							},
							splitLine: {
								show: false
							},
							splitNumber: 10,
							min: 'dataMin',
							max: 'dataMax',
							show: true,
							axisPointer: {
								z: 100
							},
							axisLabel: {
								fontSize: 10
							},
						}
					],
					yAxis: [{
							gridIndex: 0,
							name: "热度",
							scale: true,
							position: 'right',
							min: 0,
							max: 100,
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: '#b1afb3',
									width: 1
								}
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}'
							},
						}, 
						{
							gridIndex: 0,
							// name: "热度",
							min: 0,
							max: 100,
							scale: true,
							offset: 2,
							splitArea: {
								show: false
							},
							axisLine: {
								lineStyle: {
									color: '#b1afb3',
									width: 1
								}
							},
							splitLine: false,
							position: 'left',
						}, {
							gridIndex: 1,
							name: "涨停",
							scale: true,
							position: 'right',
							min: 0,
							max: 150,
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: '#b1afb3',
									width: 1
								}
							},
							axisTick:{
								show:true
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}'
							},
						},
						{
							gridIndex: 1,
							name: "连板高度",
							scale: true,
							position: 'left',
							min: 0,
							max: 12,
							splitNumber: 10,
							axisLine: {
								lineStyle: {
									color: '#b1afb3',
									width: 1
								}
							},
							axisTick:{
								show:true
							},
							splitLine: {
								show: false
							},
							splitArea: {
								show: false
							},
							axisLabel: {
								interval: 0,
								formatter: '{value}'
							},
						},
					],
					dataZoom: [{
							type: 'inside',
							start: this.zoom_start,
							end: this.zoom_end
						},
						{
							show: true,
							type: 'slider',
							xAxisIndex: [0, 1],
							y: '90%',
							start: this.zoom_start,
							end: this.zoom_end
						}
					],
					series: []
				}
			}
		},
		computed: {
			echartsTheme(){ return this.theme==='dark' ? 'site-dark' : null },
			totalItems(){ return this.stocks_pool ? this.stocks_pool.length : 0; },
			totalPages(){ return Math.max(1, Math.ceil(this.totalItems / (this.pageSize || 1))); },
			pagedStocks(){
				const size = this.pageSize || 10;
				const page = Math.min(Math.max(1, this.currentPage || 1), this.totalPages);
				const start = (page - 1) * size;
				return this.stocks_pool.slice(start, start + size);
			},
			klineColClass(){
				switch(this.klineCols){
					case 1: return 'col-12';
					case 2: return 'col-12 col-md-6';
					case 3: return 'col-12 col-md-4';
					case 4: return 'col-12 col-md-3';
					default: return 'col-12';
				}
			}
		},
		watch: {
			stocks_pool(){
				if(this.currentPage > this.totalPages){ this.currentPage = this.totalPages; }
			}
			,
			buyDate(val){ this.calendarDate = val; }
		},
		methods: {
			onCalendarInput(val){ if(val){ this.buyDate = val; this.fetchPoolByDate(val); } },
			fetchPoolByDate(date){
				let reset_pool = this.reset_stock_pool;
				let quant_code = this.quant_code;
				request_zzquant({url:'/v2/api/quant/stock/pool/jyzj/'+quant_code+'?date='+date}).then(res => { reset_pool(res['data']['data']); });
			},
			prevPage(){
				if(this.currentPage>1){ this.currentPage--; }
			},
			nextPage(){
				if(this.currentPage < this.totalPages){ this.currentPage++; }
			},
			refresh_interval(){
				let  myDate = new Date();
				let day = myDate.getDay() //获取当前星期X(0-6,0代表星期天)
				let hour = myDate.getHours(); //获取当前小时数(0-23)
				if (0<day && day<6 && 9<=hour && hour<=15){
					this.refresh();
				}else{
					console.log("day 非交易时间不刷新");
				}
			},
			show_kline(stock_code,stock_name){
				this.symbol_code=stock_code;
				this.symbol_name=stock_name;
			},
			reset_stock_pool(pool){
				this.stocks_pool=pool;
			},
			// onClickChart(params){
			// 	let date = params.name;
			// 	let seriesName = params.seriesName;
			// 	if(seriesName== '按天情绪'){
			// 		console.log(date, params);
			// 	}
			// },
			refresh() {
				let reset_pool = this.reset_stock_pool;
				let quant_code = this.quant_code;
				this.line['tooltip']  = {
						trigger: 'axis',
						axisPointer: {
							type: 'cross'
						},
						triggerOn: 'click',
						formatter: (params) => {
							var h = params[0].name + " <br />";
							params.forEach((item) => {
								if (item.seriesName == '按天情绪') {
									let date = item.name
									// console.log(date);
									this.buyDate = date
									request_zzquant({url:'/v2/api/quant/stock/pool/jyzj/'+quant_code+'?date='+date}).then(res => {
										reset_pool(res['data']['data'])
									})
									
									h += item.seriesName + ":" + item.value + " <br />";
								} 
								else {
									h += item.seriesName + ":" + item.value + " <br />";
								}
							});
							return h;
						}
					},
				axios.all([
						request_zzquant({
							'url': '/open/sentiment/hot/day?st=200'
						}),
						request_zzquant({
							'url': '/open/sentiment/hot/today'
						}),
					])
					.then(axios.spread((resp1, resp2) => {
						let splitDataItem = this.splitData(resp1['data']['data'], resp2['data']['data']);
						let series_data = []
						// console.log(splitDataItem);
						series_data.push({
							name: '按天情绪',
							data: splitDataItem.earn_effect,
							type: 'line',
							symbol: 'circle',
							showSymbol: true,
							xAxisIndex: 0,
							yAxisIndex: 0,	// 对应上面定义的y轴数据的格式，数组的下标进行对应
							markLine: {
								data: [{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											width: 1,
											type: "solid",
											symbol: 'circle',
											color: upBorderColor,
										},
										label: {
											position: 'end',
											formatter: "沸点风险(90)"
										},
										yAxis: 90
									},
									{
										// silent: false,
										lineStyle: { //警戒线的样式  ，虚实  颜色
											type: "dotted",
											color: upBorderColor,
										},
										label: {
											position: 'end',
											formatter: "过热(75)"
										},
										yAxis: 75
									},
									{
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												type: "dashed",
												symbol: 'circle',
												color: downBorderColor,
											},
											label: {
												position: 'end',
												formatter: "微冷(45)"
											},
											yAxis: 45
										}, {
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												type: "dotted",
												symbol: 'circle',
												color: downBorderColor,
											},
											label: {
												position: 'end',
												formatter: "过冷(35)"
											},
											yAxis: 35
										},
										{
											// silent: false,
											lineStyle: { //警戒线的样式  ，虚实  颜色
												width: 1,
												type: "solid",
												color: downBorderColor,
											},
											label: {
												position: 'end',
												formatter: "冰点机会(25)"
											},
											yAxis: 25
										}
								]
							},
							lineStyle: {
								normal: {
									width: 2,
									opacity: 0.9,
									// color: upColor
								}
							},
							
						});

						series_data.push({
							xAxisIndex: 0,
							yAxisIndex: 0,	//数组里面的下标对应
							name: '亏钱效应',
							data: splitDataItem.lose_effect,
							type: 'line',
							symbol: 'circle',
							showSymbol: true,
							lineStyle: {
								normal: {
									width: 2,
									opacity: 0.9,
									color: downColor
								}
							},
						});

						series_data.push({
							xAxisIndex: 1,
							yAxisIndex: 2,
							name: '涨停数',
							data: splitDataItem.zt_num,
							type: 'bar',
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: upColor
								}
							},
							label: {
								show: true,
								position: 'top',
							},
							symbol: 'circle'
						});
						
						series_data.push({
							xAxisIndex: 1,
							yAxisIndex: 3,
							name: '连板高度',
							data: splitDataItem.lb_high,
							type: 'line',
							itemStyle: {
								normal: {
									width: 1,
									opacity: 0.7,
									color: upColor
								}
							},
							label: {
								show: true,
								position: 'top',
							},
							symbol: 'circle'
						});
						
						this.line['xAxis'] = [
							{data: splitDataItem.categoryData},
							{data: splitDataItem.categoryData},
							];
						
						this.line['series'] = series_data;
						this.line['legend'] = {
							data: ['按天情绪'],
						};
					}))
					.catch(err => {
						console.log(err);
					})
			},
			splitData(rawData, rowData2) {
				let [categoryData, earn_effect, lose_effect, lb_high, zt_num] = [
					[],
					[],
					[],
					[],
					[]
				]; //解构赋值
				let item2 = rowData2['info'][0];
				if (rawData['info'][0]['Day'] < item2['Day']) {
					categoryData.push(item2['Day']);
					earn_effect.push(item2['strong']);
					lose_effect.push(item2['df_num']);
					lb_high.push(item2['lbgd']);
					zt_num.push(item2['ztjs']);
				}
				const now = new Date();
				const hour = now.getHours();
				if(hour<9 || hour > 15){
					let today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + (now.getDate());
					if (hour > 15){
						today = now.getFullYear() + '-' + (now.getMonth() + 1) + '-' + (now.getDate()+1);
					}
					categoryData.push(today);
					earn_effect.push(0);
					lose_effect.push(0);
					lb_high.push(0);
					zt_num.push(0);
				}
				
				rawData['info'].forEach(item => {
					categoryData.push(item['Day']);
					earn_effect.push(item['strong']);
					lose_effect.push(item['df_num']);
					lb_high.push(item['lbgd']);
					zt_num.push(item['ztjs']);
				})
				
				return {
					categoryData: categoryData.reverse(),
					earn_effect: earn_effect.reverse(),
					lose_effect: lose_effect.reverse(),
					lb_high: lb_high.reverse(),
					zt_num: zt_num.reverse(),
				};
			},
			// 最后在beforeDestroy()生命周期内清除定时器：
			beforeDestroy() {
				window.removeEventListener('site-theme-changed', this.onThemeChanged)
				clearInterval(this.timer);        
				this.timer = null;
			}
		}
	}
</script>

<style>
.quant_jyjy {
	width: 100%;
	height: 400px;
}
</style>
